"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _light = _interopRequireWildcard(require("react-syntax-highlighter/dist/light"));

var _javascript = _interopRequireDefault(require("highlight.js/lib/languages/javascript"));

(0, _light.registerLanguage)('javascript', _javascript["default"]);

var PreTag = function PreTag(_ref) {
  var children = _ref.children;
  return _react["default"].createElement("pre", {
    className: "highlight-block"
  }, children);
};

var CodeTag = function CodeTag(_ref2) {
  var children = _ref2.children;
  return _react["default"].createElement("code", {
    className: "hljs javascript"
  }, children);
};

var CodeBlock = function CodeBlock(_ref3) {
  var code = _ref3.code;
  return _react["default"].createElement(_light["default"], {
    language: "javascript",
    useInlineStyles: false,
    PreTag: PreTag,
    CodeTag: CodeTag
  }, code);
};

CodeBlock.propTypes = {
  code: _propTypes["default"].string
};
PreTag.propTypes = {
  children: _propTypes["default"].node
};
CodeTag.propTypes = {
  children: _propTypes["default"].node
};
var _default = CodeBlock;
exports["default"] = _default;